import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { FeatureName } from '@wilson/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionsState } from '../state/permissions.state';

/**
 * @deprecated Use FeatureSignalPipe instead. Signal pipes are more performant and easier to use.
 */
@Pipe({
  name: 'featurePure',
  standalone: false,
})
export class FeaturePurePipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(value: FeatureName): Observable<boolean> {
    return this.store
      .select(PermissionsState.featurePermissions)
      .pipe(map((features: string[]) => features.includes(value)));
  }
}
